import ActionsForm from '@/shared/mixins/actionsForm'
import Tools from '@/components/tools/Tools'
import CampaignSearchForm from './search-form.js'

const CampaignSearchModel = {
  nome: null,
  tipo: null
}

export default {
  mixins: [ActionsForm],
  name: 'CampanhaSearch',
  data () {
    return {
      data: CampaignSearchModel,
      form: CampaignSearchForm
    }
  },
  props: {
    parentComponent: {
      type: Object
    }
  },
  methods: {
    onLoad () {
      this.onClearFilters()
    },
    onClearFilters () {
      Tools.SetFormDefaultValues(this.form)
      this.form.nome.value = null
      this.form.tipo.value = null
      this.parentComponent.filters = null
      this.parentComponent.onLoad()
    },
    onValidateFilters () {
      let result = true
      Tools.SetValueToSave(this.form, this.data)
      return result
    },
    onFilter () {
      if (this.onValidateFilters()) {
        this.$eventHub.emit('Filter', { filters: this.data })
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/campaign/components/search/search.js